import React from 'react';

import styles from './PageTitle.module.scss';

const PageTitle = ({ text }) => {
  return (
    <h2 id={styles.pageTitle}>
      {text}
    </h2>
  );
};

export default PageTitle;
